import './ShareToolbarButton.css';

function ShareIconSmall() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
      />
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="16 6 12 2 8 6"
      />
      <line
        x1="12"
        y1="2"
        x2="12"
        y2="15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * @param {{ onClick: () => void, className?: string, label?: string }} props
 */
export function ShareToolbarButton({
  onClick,
  className = '',
  label = 'Share this search',
}) {
  return (
    <button
      type="button"
      className={`share-toolbar-btn${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={label}
    >
      <ShareIconSmall />
      <span className="share-toolbar-btn__label">Share</span>
    </button>
  );
}
